import { Popup } from "../popup";

export class FeedbackPopup extends Popup {
    close = () => this.closePopup();
    open = () => this.openPopup();
}
